require("./UI/skipWinsButton.js");
require("../../node_modules/hammerjs/hammer.min.js");
require("../../libs/reflex-library/src/lib/shape.js");
require("./pixi-spine.js");
require("../../libs/reflex-library/src/lib/gsap.min.js");
require("./LoaderController.js");
require("./game.js");
require("./helperFunctions.js");
require("./gameController.js");
require("./spinController.js");
require("./ParticleController.js");
require("./Feature/FreeSpins/freespinsController.js");
require("./Feature/FreeSpins/FreeSpinsSpinButtonComponent.js");
require("./Feature/FreeSpins/FreeSpinsSkipButtonComponent.js");
require("./Feature/FreeSpins/FreeSpinsDialogView.js");
require("./GameHelpers.js");
require("../../libs/reflex-library/src/lib/screenDimObject.js");
require("../../libs/reflex-library/src/lib/screenshotAnimator.js");
require("./SymbolWinBorderAnimController.js");
require("./AudioController.js");
require("./ShowReelView.js");
require("./UI/GameSlamStopButtonComponent.js");
require("./UI/SettingSound.js");
require("./BigWinController.js");
require("../../libs/reflex-library/src/lib/colourBox.js");
require("./UI/LuckyBetToggleController.js");
require("./Feature/FreeSpins/FreeSpinsMeterComponent.js");
require("../../libs/reflex-library/src/lib/spine.js");
require("./MessagePopperView.js");
require("./UI/StakeMinusButtonComponent.js");
require("./UI/StakePlusButtonComponent.js");
require("./MessageBoxController.js");
require("./WinTextController.js");
require("./ReelSpinnerVisualDevils.js");
require("./CentreDevil.js");
require("./BuyBonus/BuyBonusButtonComponent.js");
require("./BuyBonus/BuyBonusPopupView.js");
require("./UI/SettingsMenuController.js");
require("./UI/SettingsMenuButtonComponent.js");
require("./Animations/BackgroundAnimsView.js");
require("./ReelSpinnerVisualSCS.js");
require("./winAnimations/movieSymbolAnimator.js");
require("./winAnimations/royalSymbolAnimator.js");
require("./winAnimations/SymbolLandAnimator.js");
require("./winlineAnimator.js");
require("./CoinsView.js");
require("./unlocksIntroPanel.js");
require("./winController.js");
require("../../libs/reflex-library/src/lib/gsapPixiPlugin.js");
require("./MotionPathPlugin.js");
require("./ScrollContainer.js");

//Setting Menu Buttons
require("./SystemSettings/SystemSettingVolumeButtonComponent.js");
require("./SystemSettings/SystemSettingsButtonComponent.js");
require("./SystemSettings/SystemSettingsCloseComponent.js");
require("./SystemSettings/SystemSettingsIntroScreenButtonComponent.js");
require("./SystemSettings/SystemSettingsSoundsComponents.js");
require("./SystemSettings/SystemSettingsBoxView.js");

//Stake/Bet Menu
require("./StakeSettings/stakeSelectionPopup_ext.js");

//Autoplay
require("./AutoplaySettings/autoplayManager-ext.js");

//Menubar
require("./SideMenu/SideMenuCloseComponent.js");
require("./SideMenu/SideMenuHelpComponent.js");
require("./GameRecoveryController.js");

// DANNY
require("./Animations/BackgroundAnimator.js");
require("./Feature/DevilCharacter/DevilCharacter.js");
require("./Feature/ReelBorderFire/ReelBorderFire.js");
require("./PotMeters/PotMeters.js");
require("./Chests.js");
require("./CollectMeter.js");

//Modifiers
require("./Modifiers/BoostModifier.js");
require("./Modifiers/MultiModifier.js");
require("./symbolNudgeHandler.js");
require("./Modifiers/ModifierAwardedPanel.js");
